export function winnerName(winner) {
  return [winner?.firstName, winner?.lastName1, winner?.lastName2].filter(Boolean).join(' ').trim();
}

export function hasRaffleWinner(value) {
  if (!value || Array.isArray(value) || typeof value !== 'object') return false;
  return Number(value.sorteoWinnerId) > 0 || Number(value.confId) > 0 ||
    Boolean(value.couponId && String(value.couponId).trim() && !/^0+$/.test(String(value.couponId).trim())) ||
    Boolean(value.machine || value.document || winnerName(value));
}

export function couponLabel(winner) {
  return winner?.couponId != null && String(winner.couponId).trim()
    ? String(winner.couponId).trim() : 'GANADOR';
}
